import { render, staticRenderFns } from "./NotificationComponentSelector.vue?vue&type=template&id=123ce7be&scoped=true&lang=pug&"
import script from "./NotificationComponentSelector.vue?vue&type=script&lang=js&"
export * from "./NotificationComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123ce7be",
  null
  
)

export default component.exports